import { render, staticRenderFns } from "./ProposalEdit.vue?vue&type=template&id=6497f650"
import script from "./ProposalEdit.vue?vue&type=script&lang=js"
export * from "./ProposalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports